export enum ToastStates {
    HIDDEN = 1,
    PROCESSING = 2,
    FAILURE = 3,
    SUCCESS = 4,
}
